// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__exZGR","row":"Option_row__D95Zs"};